import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Stack, Typography, Alert, Button, Box, Paper } from '@mui/material'
import { WifiOff, CloudOff } from '@mui/icons-material'

import LogoSrc from '@/assets/img/logo.gif'

interface OfflineLoginPageProps {}

export function OfflineLoginPage(props: OfflineLoginPageProps) {
  const { t } = useTranslation()
  const [showRetryButton, setShowRetryButton] = useState(true)

  const handleRetry = () => {
    // Check if we're back online
    if (navigator.onLine) {
      window.location.reload()
    } else {
      setShowRetryButton(false)
      setTimeout(() => setShowRetryButton(true), 3000)
    }
  }

  const handleGoOnline = () => {
    // Provide instructions to user
    const instructions = t('offline.login.goOnlineInstructions')
    alert(instructions)
  }

  return (
    <Container component="main" maxWidth="sm" sx={{ height: '100vh', py: 4 }}>
      <Stack spacing={3} alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
        <img alt="logo" src={LogoSrc} width="200px" />

        <Paper elevation={3} sx={{ p: 4, width: '100%', textAlign: 'center' }}>
          <Stack spacing={3} alignItems="center">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <WifiOff sx={{ fontSize: 40, color: 'warning.main' }} />
              <CloudOff sx={{ fontSize: 40, color: 'error.main' }} />
            </Box>

            <Typography variant="h4" color="text.primary" gutterBottom>
              {t('offline.login.title')}
            </Typography>

            <Alert severity="warning" sx={{ width: '100%' }}>
              <Typography variant="body1">{t('offline.login.noConnection')}</Typography>
            </Alert>

            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
              {t('offline.login.instructions')}
            </Typography>

            <Stack direction="row" spacing={2} sx={{ width: '100%', pt: 2 }}>
              <Button variant="contained" fullWidth onClick={handleRetry} disabled={!showRetryButton}>
                {t('offline.login.retry')}
              </Button>

              <Button variant="outlined" fullWidth onClick={handleGoOnline}>
                {t('offline.login.help')}
              </Button>
            </Stack>

            <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
              {t('offline.login.footer')}
            </Typography>
          </Stack>
        </Paper>
      </Stack>
    </Container>
  )
}
